import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import PropTypes from "prop-types";
import { acceptCookies, logout, resetAuthUser } from "../actions/authActions";
import { changePage } from "../actions/changePageAction";
import { clearErrors } from "../actions/errorActions";
import { getProjects } from "../actions/projectActions";
import { changeLanguage } from "../actions/userActions";
import NavigationLink from "./container/NavigationLink";
import i18n from "./helper/i18n";
import { Button, Nav, Navbar, NavDropdown } from "react-bootstrap";
import InlineLink from "./container/InlineLink";
import NavigationLinkAbs from "./container/NavigationLinkAbs";
import ProfileLink from "./container/ProfileLink";
import { Translation } from "./helper/transComp";

class HeaderLoggedOut extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      width: 0,
      displMenu: false,
      languages: ["en", "de", "fr"],
      currLan: "en",
      register: false,
      login: false,
      images: [],
      isAuthenticated: false,
      isSubPage: false,
      showInactivityMessage: false,

      solutions: [
        { trans: "HeaderPlateform", filter: "software" },
        { trans: "HeaderUtils", filter: "solutions" },
        { trans: "SolutionsToDoList", filter: "solutions/todolist" },
        { trans: "SolutionsGantt", filter: "solutions/gantt" },
        { trans: "SolutionsKanban", filter: "solutions/kanban" },
        { trans: "SolutionsWBS", filter: "solutions/wbs" },
      ],
      offer: [
        { trans: "HeaderFormationChoose", filter: "training" },
        { trans: "HeaderCatalogue", filter: "courses" },
      ],
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  static propTypes = {
    auth: PropTypes.object.isRequired,
    changePage: PropTypes.func.isRequired,
    page: PropTypes.object.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    getProjects: PropTypes.func.isRequired,
    image: PropTypes.object,
    logout: PropTypes.func.isRequired,
    resetAuthUser: PropTypes.func.isRequired,
    changeLanguage: PropTypes.func.isRequired,
    acceptCookies: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
  };

  componentDidMount() {
    /*************Added this */
    // Vérifier s'il y a une raison de déconnexion à afficher
    const disconnectionReason = localStorage.getItem('disconnectionReason');
    if (disconnectionReason === 'inactivity') {
      this.setState({ showInactivityMessage: true });
      localStorage.removeItem('disconnectionReason');
    }
    // NOUVEAU: Gérer les nouvelles raisons de déconnexion
    if (disconnectionReason === 'max_duration_reached' || disconnectionReason === 'extended_session_timeout') {
      alert("Votre session a atteint sa durée maximale et a été fermée.");
      localStorage.removeItem('disconnectionReason');
    }
    /*********** */
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);

    let domainPath = window.location?.pathname || "";
    let choosenLanguage = "en";

    if (
      !domainPath.includes("emailValidation") &&
      !domainPath.includes("resetPassword")
    ) {
      let subdomain = domainPath.split("/");
      if (subdomain[0] === "") subdomain.shift();

      if (["fr", "de", "en"].includes(subdomain[0])) {
        const sLan = subdomain[0].toLowerCase();
        i18n.changeLanguage(sLan);
        this.props.changeLanguage(sLan);
        choosenLanguage = sLan;
        if (subdomain[2]) this.setState({ isSubPage: true });
      } else {
        if (this.props.user?.language) {
          choosenLanguage = this.props.user.language || "en";
          i18n.changeLanguage(choosenLanguage);
          this.props.changeLanguage(choosenLanguage);
        } else {
          if (["fr", "de"].includes(i18n.language))
            choosenLanguage = i18n.language;
          this.props.changeLanguage(choosenLanguage);
        }
        const sPage = subdomain[0]?.toLowerCase() || "";
        const subPage = subdomain[1]?.toLowerCase() || "";
        this.props.props.history.push(
          `/${choosenLanguage}/${sPage}${subPage ? `/${subPage}` : ""}`
        );
      }
    }
    this.setState({ currLan: choosenLanguage });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  componentDidUpdate() {
    const { isAuthenticated } = this.props.props;
    if (this.state.isAuthenticated !== isAuthenticated) {
      this.setState({ isAuthenticated });
    }
    if (this.state.login || this.state.register) {
      if (isAuthenticated) {
        this.setState({ login: false, register: false, isOpen: false });
        this.props.changePage("home");
        this.props.props.clearErrors();
      }
    }
    if (
      this.props.image?.images &&
      this.props.image.images !== this.state.images
    ) {
      this.setState({ images: this.props.image.images });
    }
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth });
  }

  getLangTxt = () => {
    switch (this.state.currLan) {
      case "de":
        return "DE";
      case "fr":
        return "FR";
      default:
        return "EN";
    }
  };

  render() {
    const curr = this.state.currLan;

    return (
      <Fragment>
        {this.state.showInactivityMessage && (
          <div
            className="alert alert-warning"
            role="alert"
            style={{
              position: "fixed",
              top: "80px",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 1000,
              width: "90%",
              maxWidth: "600px",
            }}
          >
            <strong>Session expirée :</strong> Vous avez été déconnecté car vous
            étiez inactif pendant plus de 10 minutes.
            <button
              type="button"
              className="btn-close"
              onClick={() => this.setState({ showInactivityMessage: false })}
            />
          </div>
        )}

        {this.props.auth?.acceptCookies === null && (
          <div
            style={{
              height: "30vh",
              maxHeight: "600px",
              position: "fixed",
              zIndex: 60,
              bottom: 0,
              backgroundColor: "#0000009c",
              color: "#fff",
              width: "100%",
              padding: "1rem",
            }}
          >
            <div style={{ maxWidth: "700px", margin: "auto" }}>
              <div>
                <Translation str={"HeaderCookies"} />{" "}
                <div>
                  <InlineLink
                    onClick={() => {}}
                    filter={`https://www.luckiwi.com/${curr}/cookies`}
                    style={{ color: "#fff" }}
                  >
                    <Translation str={"HeaderLearnMore"} />
                  </InlineLink>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "0.4rem",
                }}
              >
                <Button
                  className="btn-submit"
                  onClick={() => this.props.acceptCookies(false)}
                >
                  <Translation str={"HeaderDecline"} />
                </Button>
                <Button
                  className="btn-submit"
                  onClick={() => {
                    window["ga-disable-G-218QT8EDCS"] = false;
                    window.dataLayer = window.dataLayer || [];
                    function gtag() {
                      window.dataLayer.push(arguments);
                    }
                    gtag("js", new Date());
                    gtag("config", "G-218QT8EDCS");
                    this.props.acceptCookies(true);
                  }}
                >
                  <Translation str={"HeaderAccept"} />
                </Button>
              </div>
            </div>
          </div>
        )}

        <header>
          <Navbar bg="light" expand="md" fixed="top">
            <ProfileLink
              onClick={() => this.setState({ isOpen: false })}
              filter={
                this.props.props.isAuthenticated
                  ? "/home"
                  : this.state.isSubPage
                  ? "https://www.luckiwi.com/"
                  : "https://www.luckiwi.com/"
              }
            >
              <img
                src={`/../img/logo.webp`}
                alt="logo"
                style={{ height: "60px" }}
              />
            </ProfileLink>

            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-0 ms-auto">
                <NavDropdown
                  className="header-borderleft"
                  title={<Translation str={"HeaderSoftware"} />}
                >
                  {_.map(this.state.solutions, (tval, i) => (
                    <div className="hoverMenu buttonContainerStart" key={i}>
                      <NavigationLinkAbs
                        navLinkClicked={() => this.setState({ isOpen: false })}
                        filter={`https://www.luckiwi.com/${curr}/${tval.filter}`}
                      >
                        <Translation str={tval.trans} />
                      </NavigationLinkAbs>
                    </div>
                  ))}
                </NavDropdown>

                <NavDropdown
                  className="header-borderleft"
                  title={<Translation str={"HeaderFormation"} />}
                >
                  {_.map(this.state.offer, (tval, i) => (
                    <div className="hoverMenu buttonContainerStart" key={i}>
                      <NavigationLinkAbs
                        navLinkClicked={() => this.setState({ isOpen: false })}
                        filter={`https://www.luckiwi.com/${curr}/${tval.filter}`}
                      >
                        <Translation str={tval.trans} />
                      </NavigationLinkAbs>
                    </div>
                  ))}
                </NavDropdown>

                <NavigationLinkAbs
                  navLinkClicked={() => this.setState({ isOpen: false })}
                  filter={`https://www.luckiwi.com/${curr}/consulting`}
                >
                  <Translation str={"HeaderConsulting"} />
                </NavigationLinkAbs>

                {/* CONTACT (app) */}
                <NavigationLinkAbs
                  navLinkClicked={() => this.setState({ isOpen: false })}
                  filter={`https://app.luckiwi.com/${curr}/contact`}
                >
                  <span>
                    <Translation str={"HeaderContact"} />
                  </span>
                </NavigationLinkAbs>

                {/* LANGUES */}
                <NavDropdown
                  title={
                    <span>
                      <img
                        src={"/img/world.svg"}
                        alt="language"
                        style={{ width: "20px" }}
                      />{" "}
                      {this.getLangTxt()}
                    </span>
                  }
                  id="basic-nav-dropdown"
                  className="header-borderleft"
                >
                  {_.map(this.state.languages, (code, i) => {
                    const active = this.state.currLan === code;
                    const label =
                      code === "en"
                        ? "English"
                        : code === "de"
                        ? "Deutsch"
                        : "Français";
                    const img =
                      code === "en"
                        ? "english.webp"
                        : code === "de"
                        ? "german.webp"
                        : "french.webp";
                    return (
                      <NavDropdown.Item
                        className="hoverMenu buttonContainerStart"
                        style={{ backgroundColor: active ? "#d6d6d6" : "" }}
                        onClick={(e) => {
                          e.preventDefault();
                          this.setState({ currLan: code, isOpen: false });
                          i18n.changeLanguage(code);
                          this.props.changeLanguage(code);

                          const domainPath = window.location?.pathname || "";
                          const parts = domainPath.split("/").filter(Boolean);
                          let page = parts
                            .filter((p) => !["fr", "en", "de"].includes(p))
                            .join("/");
                          this.props.props.history.push(`/${code}/${page}`);
                        }}
                        key={i}
                      >
                        <span
                          style={{ marginLeft: "0.25rem", cursor: "pointer" }}
                        >
                          <img
                            src={`/../img/${img}`}
                            style={{ height: "30px", margin: "0 10px 0 5px" }}
                            alt={label}
                          />
                          <span>{label}</span>
                        </span>
                      </NavDropdown.Item>
                    );
                  })}
                </NavDropdown>

                {/* LOGIN */}
                <NavigationLink
                  navLinkClicked={() => this.setState({ isOpen: false })}
                  filter={`./${curr}/login`}
                >
                  <Translation str={"HeaderLogin"} />
                </NavigationLink>

                {/* REGISTER */}
                {window.location.host.split(".")[1] ? (
                  window.location.host.split(".")[0] === "app" ? (
                    <NavigationLink
                      navLinkClicked={() => this.setState({ isOpen: false })}
                      filter={`./${curr}/register`}
                      id="headerForBackground"
                    >
                      <span id="backgrounded">
                        <Translation str={"HeaderRegister"} />
                      </span>
                    </NavigationLink>
                  ) : null
                ) : (
                  <NavigationLink
                    navLinkClicked={() => this.setState({ isOpen: false })}
                    id="headerForBackground"
                    filter={`./${curr}/register`}
                  >
                    <span id="backgrounded">
                      <Translation str={"HeaderRegister"} />
                    </span>
                  </NavigationLink>
                )}
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </header>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  page: state.page,
  isAuthenticated: state.auth.isAuthenticated,
  image: state.image,
  user: state.user,
});

export default connect(mapStateToProps, {
  changePage,
  clearErrors,
  getProjects,
  logout,
  resetAuthUser,
  changeLanguage,
  acceptCookies,
})(HeaderLoggedOut);
